module.exports = __webpack_public_path__ + "assets/img/IMG032.fba7c160.png";